import React from 'react';
import { Clock } from 'lucide-react';
import ProductCard from './ProductCard';

const STORAGE_KEY = 'rns_recently_viewed';
const MAX_ITEMS = 8;

/**
 * Save a product to recently viewed (localStorage).
 * Called from ProductDetailPage when a product is loaded.
 */
export function saveRecentlyViewed(product) {
  try {
    const existing = getRecentlyViewed();
    // Remove current product if already present, then prepend
    const filtered = existing.filter(p => p.id !== product.id);
    const minimal = {
      id: product.id,
      name: product.name,
      brand: product.brand,
      category: product.category,
      images: product.images,
      price: product.price,
      compare_price: product.compare_price,
      uae_market_price: product.uae_market_price,
      avg_rating: product.avg_rating,
      reviews_count: product.reviews_count,
      stock: product.stock,
      featured: product.featured,
      specs: product.specs,
    };
    const updated = [minimal, ...filtered].slice(0, MAX_ITEMS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch {
    // localStorage not available
  }
}

export function getRecentlyViewed() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
}

export default function RecentlyViewedProducts({ excludeId }) {
  const items = getRecentlyViewed().filter(p => p.id !== excludeId);

  if (items.length === 0) return null;

  return (
    <div className="mt-12" data-testid="recently-viewed-section">
      <div className="flex items-center gap-2 mb-6">
        <div className="h-px w-6 bg-primary" />
        <Clock size={16} className="text-primary" />
        <h2 className="section-heading text-2xl text-white">Recently Viewed</h2>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        {items.slice(0, 4).map(p => (
          <ProductCard key={p.id} product={p} />
        ))}
      </div>
    </div>
  );
}
